import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main/Main'
import Home from '@/components/main/Home'
import About from '@/components/main/About'
import Class from '@/components/main/Class'
import News from '@/components/main/News'
import Read from '@/components/main/Read'
import Partner from '@/components/main/Partner'
import Product from '@/components/main/Product'
import Login from '@/components/account/Login'
import Invite from '@/components/account/Invite'
import Bind from '@/components/account/Bind'
import Signup from '@/components/account/Signup'
import ResetPassword from '@/components/account/ResetPassword'
import SetPassword from '@/components/account/SetPassword'
import Contact from '@/components/account/Contact'
import GetCode from '@/components/GetCode'
import addPrescriptionContact from '@/components/kaifang/addPrescriptionContact'
import prescriptionInfo from '@/components/kaifang/prescriptionInfo'
import prescriptionResult from '@/components/kaifang/prescriptionResult'
import Prescription from '@/components/kaifang/Prescription'
import addServiceContact from '@/components/addServiceContact.vue'
import serviceResult from '@/components/serviceResult'
import prescriptionImage from '@/components/kaifang/prescriptionImage.vue'
import order from '@/components/account/order'
import apply from '@/components/account/apply'
import applying from '@/components/account/applying'
import userInfo from '@/components/account/userInfo'
import fulfillmentConfirm from '@/components/fulfillment/fulfillmentConfirm'
import fulfillmentOrder from '@/components/fulfillment/fulfillmentOrder'
import wjtpay from '@/components/pay/wjtpay'
import wjtpayCheck from '@/components/pay/wjtpayCheck'
import address from '@/components/account/address'
import amount from '@/components/account/amount'
import protocol from '@/components/account/protocol'
import fulfillmentProtocol from '@/components/account/fulfillmentProtocol'
import serviceAgreement from '@/components/account/serviceAgreement'
import handmadePrescription from '@/components/kaifang/handmadePrescription'
import handmadePrescriptionConfirm from '@/components/kaifang/handmadePrescriptionConfirm'
import handmadePrescriptionDetails from '@/components/kaifang/handmadePrescriptionDetails'
import medicalRecords from '@/components/account/medicalRecords'
Vue.use(Router)

export default new Router({
  mode:'history',
  scrollBehavior() {
    return {x:0,y:0};
  },
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children:[
        {
          path: '/',
          name: 'Home',
          component: Home,
          meta:{
            title:'闻景科技'
          }
        },
        {
          path: '/Product',
          name: 'Product',
          component: Product,
          meta:{
            title:'闻景产品'
          }
        },
        {
          path: '/About',
          name: 'About',
          component: About,
          meta:{
            title:'关于闻景'
          }
        },
        {
          path: '/Class',
          name: 'Class',
          component: Class,
          meta:{
            title:'闻景课堂'
          }
        },
        {
          path: '/News',
          name: 'News',
          component: News,
          meta:{
            title:'闻景新闻'
          }
        },
        {
          path: '/Read',
          name: 'Read',
          component: Read,
          meta:{
            title:'有偿资讯'
          }
        },
        {
          path: '/Partner',
          name: 'Partner',
          component: Partner,
          meta:{
            title:'合作共赢'
          }
        },
        {
          path: '/addPrescriptionContact',
          name: 'addPrescriptionContact',
          component: addPrescriptionContact,
          meta:{
            title:'患者信息',
            requireAuth: true,
          }
        },
        {
          path: '/Contact',
          name: 'Contact',
          component: Contact,
          meta:{
            title:'患者',
            requireAuth: true,
          }
        },
        {
          path: '/medicalRecords',
          name: 'medicalRecords',
          component: medicalRecords,
          meta:{
            title:'就诊记录',
            requireAuth: true,
          }
        },
        {
          path: '/prescriptionInfo',
          name: 'prescriptionInfo',
          component: prescriptionInfo,
          meta:{
            title:'症状信息',
            requireAuth: true,
          }
        },
        {
          path: '/prescriptionResult',
          name: 'prescriptionResult',
          component: prescriptionResult,
          meta:{
            title:'处方信息',
            requireAuth: true,
          }
        },
        {
          path: '/Prescription',
          name: 'Prescription',
          component: Prescription,
          meta:{
            title:'支付成功',
            requireAuth: true,
          }
        },
        {
          path: '/addServiceContact',
          name: 'addServiceContact',
          component: addServiceContact,
          meta:{
            first:true,
            requireAuth: true,
          }
        },
        {
          path: '/serviceResult',
          name: 'serviceResult',
          component: serviceResult,
          meta:{
            requireAuth: true,
            clear:false
          }
        },
        {
          path: '/prescriptionImage',
          name: 'prescriptionImage',
          component: prescriptionImage,
          meta:{
            title:'处方笺',
            requireAuth: true,
          }
        },
        {
          path: '/order',
          name: 'order',
          component: order,
          meta:{
            title:'订单',
            requireAuth: true,
          }
        },
        {
          path: '/protocol',
          name: 'protocol',
          component: protocol,
          meta:{
            title:'隐私协议',
            requireAuth: false,
          }
        },
        {
          path: '/fulfillmentProtocol',
          name: 'fulfillmentProtocol',
          component: fulfillmentProtocol,
          meta:{
            title:'配送中心业务许可协议',
            requireAuth: false,
          }
        },
        {
          path: '/serviceAgreement',
          name: 'serviceAgreement',
          component: serviceAgreement,
          meta:{
            title:'委托服务合同',
            requireAuth: false,
          }
        },
        {
          path: '/apply',
          name: 'apply',
          component: apply,
          meta:{
            title:'申请医生',
            requireAuth: true,
          }
        },
        {
          path: '/applying',
          name: 'applying',
          component: applying,
          meta:{
            title:'申请医生',
            requireAuth: true,
          }
        },
        {
          path: '/userInfo',
          name: 'userInfo',
          component: userInfo,
          meta:{
            title:'医生信息',
            requireAuth: true,
          }
        },
        {
          path: '/fulfillmentConfirm',
          name: 'fulfillmentConfirm',
          component: fulfillmentConfirm,
          meta:{
            title:'配送订单',
            requireAuth: true,
          }
        },
        {
          path: '/fulfillmentOrder',
          name: 'fulfillmentOrder',
          component: fulfillmentOrder,
          meta:{
            title:'订单详情',
            requireAuth: true,
          }
        },
        {
          path: '/address',
          name: 'address',
          component: address,
          meta:{
            title:'我的地址',
            requireAuth: true,
          }
        },
        {
          path: '/wjtpay',
          name: 'wjtpay',
          component: wjtpay,
          meta:{
            title:'收银台',
            requireAuth: true,
          }
        },
        {
          path: '/wjtpayCheck',
          name: 'wjtpayCheck',
          component: wjtpayCheck,
          meta:{
            title:'收银台',
            requireAuth: true,
          }
        },
        {
          path: '/amount',
          name: 'amount',
          component: amount,
          meta:{
            title:'分账信息',
            requireAuth: true,
          }
        },
        {
          path: '/handmadePrescription',
          name: 'handmadePrescription',
          component: handmadePrescription,
          meta:{
            title:'自拟组方',
            requireAuth: true,
          }
        },
        {
          path: '/handmadePrescriptionConfirm',
          name: 'handmadePrescriptionConfirm',
          component: handmadePrescriptionConfirm,
          meta:{
            title:'自拟组方详情',
            requireAuth: true,
          }
        },
        {
          path: '/handmadePrescriptionDetails',
          name: 'handmadePrescriptionDetails',
          component: handmadePrescriptionDetails,
          meta:{
            title:'自拟组方确认',
            requireAuth: true,
          }
        },
      ]
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        title:'登录'
      }
    },
    {
      path: '/Signup',
      name: 'Signup',
      component: Signup,
      meta: {
        title:'注册'
      }
    },
    {
      path: '/ResetPassword',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        title:'忘记密码'
      }
    },
    {
      path: '/SetPassword',
      name: 'SetPassword',
      component: SetPassword,
      meta: {
        title:'设置密码'
      }
    },
    {
      path: '/GetCode',
      name: 'GetCode',
      component: GetCode,
      meta: {
        keepAlive: true,
        title:'获取验证码'
      }
    },
    {
      path: '/Invite',
      name: 'Invite',
      component: Invite,
      meta: {
        title:'邀请'
      }
    },
    {
      path: '/Bind',
      name: 'Bind',
      component: Bind,
      meta: {
        title:'绑定'
      }
    }
  ]
})
var originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js